import React from 'react';
import { OwnershipDashboard } from './components/OwnershipDashboard';
export function App() {
  return <div className="min-h-screen bg-[#f3f2f2] text-[#080707] font-sans" data-id="element-0">
      {/* Salesforce-like global header strip */}
      

      <main data-id="element-1">
        <OwnershipDashboard data-id="element-2" />
      </main>
    </div>;
}